import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { DialogContentText } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import FlagstoneTheme from '../../../../Config/flagstoneTheme';
import { useTranslation } from 'react-i18next';
import TextField from '@mui/material/TextField';

export default function StandstillTechnicalReasonPopup(props) {

    const classes = useStyles();
    const { t } = useTranslation();
    const [remark, setRemark] = useState('');

    const handleChangeRemark = (event) => {
        setRemark(event.target.value);
    };

    return (
        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
        >
            <DialogTitle className={classes.dialogTitle} >
                {t("Technische Stilstand")}
            </DialogTitle>
            <DialogContent >
                <DialogContentText className={classes.dialogContext}>
                    <div className={classes.container}>
                        <React.Fragment>{t("Beschrijf het probleem.")}</React.Fragment>
                    
                        <TextField
                            id="outlined-multiline-flexible"
                            label={t("Description")}
                            multiline
                            maxRows={4}
                            value={remark} 
                            onChange={handleChangeRemark}
                        />
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <div className={classes.buttons}>
                    <Button className={classes.cancelButton} onClick={props.closeDialog} >
                        {t("CANCEL")}
                    </Button>
                    <Button className={classes.submitButton} onClick={() => props.action(remark)} >
                        {t("INDIENEN")}
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}


const useStyles = makeStyles(() => ({

    dialogContainer: {
        width: "520px !important",
        height: "420px !important",
        margin: "auto"
    },
    buttons: {
        width: "520px",
        textAlign: "center"
    },
    cancelButton: {
        border: "1px solid " + FlagstoneTheme.palette.primary.main,
        color: FlagstoneTheme.palette.primary.main,
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        margin: "3px",
        width: "100px",
        marginBottom: "20px"

    },
    submitButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        backgroundColor: "#4654FB",
        '&:hover': {
            backgroundColor: "#4654FB",
        },
        margin: "3px",
        width: "100px",
        marginBottom: "20px"
    },

    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "32px !important",
        },
    },
    dialogContext: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center"
    },
    headerIcon: {
        height: "80px",
        width: "100%",
        marginTop: "20px",
        textAlign: "center",
        padding: "20px",
        boxSizing: "border-box"
    },
    container: {
        display: "grid !important"
    }
}));
